<div class="modal-content">
  <div class="modal-header bg-info text-white">
    <h4 class="modal-title">Valmont Coatings Camera App</h4>
  </div>
  <div class="modal-body">
    <div class="bg-light p-4 rounded-3">
      <h1>Valmont Coatings Camera Application</h1>
      <p class="lead">
        <fa-icon animation="spin-pulse" [icon]="spinner"></fa-icon>
        Application is initializing, please wait...
      </p>
    </div>
  </div>
</div>
